import { render, staticRenderFns } from "./PageInventaire.vue?vue&type=template&id=63c2b278&"
import script from "./PageInventaire.vue?vue&type=script&lang=js&"
export * from "./PageInventaire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports